module.exports = __webpack_public_path__ + "img/mobilelegends.89f1678.jpg";